import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { KeyRound, Loader2 } from "lucide-react";
import api, { formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function ChangePassword() {
  const { user, setUser } = useAuth();
  const navigate = useNavigate();
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [saving, setSaving] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pw.length < 6) return toast.error("Mínimo 6 caracteres");
    if (pw !== pw2) return toast.error("Las contraseñas no coinciden");
    setSaving(true);
    try {
      await api.post("/auth/change-password", { new_password: pw });
      setUser({ ...user, must_change_password: false });
      toast.success("Contraseña actualizada");
      navigate("/dashboard");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally { setSaving(false); }
  };

  return (
    <div className="min-h-screen bg-xuma-bg grid place-items-center px-5">
      <div className="max-w-sm w-full">
        <div className="h-12 w-12 rounded-xl bg-xuma-primary grid place-items-center text-white mx-auto"><KeyRound className="h-6 w-6" /></div>
        <h1 className="mt-6 font-heading font-extrabold text-2xl text-xuma-dark text-center">Crea tu nueva contraseña</h1>
        <p className="mt-2 text-sm text-xuma-muted text-center">Por seguridad, cambia tu contraseña provisional para continuar.</p>
        <form onSubmit={submit} className="mt-8 space-y-4">
          <div><Label className="mb-1.5 block">Nueva contraseña</Label>
            <Input data-testid="new-password" type="password" value={pw} onChange={(e) => setPw(e.target.value)} placeholder="Mínimo 6 caracteres" /></div>
          <div><Label className="mb-1.5 block">Confirmar contraseña</Label>
            <Input data-testid="confirm-password" type="password" value={pw2} onChange={(e) => setPw2(e.target.value)} /></div>
          <Button type="submit" data-testid="change-password-submit" disabled={saving}
            className="w-full h-11 rounded-full bg-xuma-primary hover:bg-xuma-primaryHover text-white">
            {saving ? <Loader2 className="h-4 w-4 animate-spin" /> : "Guardar y continuar"}
          </Button>
        </form>
      </div>
    </div>
  );
}
